"use client";

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const evaluationAreas = [{
  title: "Socials"
}, {
  title: "SEO"
}, {
  title: "PPC"
}, {
  title: "AI Visibility"
}, {
  title: "Copy & Content"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export default function HeroEvaluation() {
  return <section id="heroevaluation" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 overflow-hidden">
      <div className="mx-auto max-w-narrative flex flex-col items-center text-center">
        
        {}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-100px"
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center w-full">
          <span className="text-xs md:text-sm tracking-[0.3em] uppercase text-foreground/60 mb-8 block font-medium">
            Free Evaluation Tool
          </span>
          
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-light tracking-widest uppercase leading-none mb-8">
            5ONDER
          </h2>
          
          <p className="max-w-2xl text-lg md:text-xl font-light text-foreground/80 leading-relaxed tracking-wide">
            A comprehensive analysis of your digital footprint. We evaluate your brand across five critical dimensions to reveal where you stand and where you need to go.
          </p>
        </motion.div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: "-50px"
      }} className="grid grid-cols-2 md:grid-cols-5 gap-x-6 gap-y-12 w-full mt-24 mb-24 text-left">
          {evaluationAreas.map((area, i) => <motion.div key={i} data-index={i} variants={itemVariants} className="border-t border-foreground/20 pt-6 flex flex-col">
              <span className="block text-xs tracking-widest text-foreground/40 mb-4 font-mono">
                0{i + 1}
              </span>
              <h3 className="font-default text-lg md:text-xl font-medium tracking-wide text-foreground">
                {area.title}
              </h3>
            </motion.div>)}
        </motion.div>

        {}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }}>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 h-14 px-8 rounded-md text-sm tracking-[0.2em] uppercase font-medium group">
              Discover Your 5ONDER Score
              <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Button>
          </Link>
        </motion.div>

      </div>
    </section>;
}